import React from 'react';

import { Box, CircularProgress, Typography } from '@mui/material';

import styles from './LoadingScreen.module.scss';

interface LoadingScreenProps {
  message?: string;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({ message = 'Loading...' }) => (
  <Box className={styles.loadingScreenRoot}>
    <CircularProgress className={styles.loadingScreenSpinner} />
    <Typography className={styles.loadingScreenMessage}>
      {message}
    </Typography>
  </Box>
);
